import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

// Route guard: renders `children` only once AuthContext has finished its
// initial localStorage check and found a logged-in user; otherwise redirects
// to /login. Replaces the old MainRouter.js bare if/else switch now that
// real routes exist for both states.
function ProtectedRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default ProtectedRoute;
